import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import UpdateOpportunity from './UpdateOpportunity';

const mapStateToProps = state => ({
  merchants: state.merchants,
});

// Provide the location as prop, in order to bust the should component render cache
export default withRouter(connect(mapStateToProps, null)(UpdateOpportunity));
